import { render } from "./bookingView.vue?vue&type=template&id=55bbc928&scoped=true"
import script from "./bookingView.vue?vue&type=script&lang=js"
export * from "./bookingView.vue?vue&type=script&lang=js"

import "./bookingView.vue?vue&type=style&index=0&id=55bbc928&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55bbc928"]])

export default __exports__